import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { formatQuotaionNumber } from 'src/common/helper';
import BtnGradient from 'src/components/common/button/BtnGradient';

const QuotationDetail = (props: any) => {
  const navigateTo = useNavigate();

  const navigateToDetail = () => {
    navigateTo(
      `/quotation/detail?patientid=${props.quoteDetail.patientid}&id=${props.quoteDetail.id}`
    );
  };

  const navigateToEdit = (patientid: number, quoteid: number) => {
    props.handleEditQuote(patientid, quoteid)
  };

  return (
    <Stack spacing='15px' height={'auto'} p={'15px'}>
      <Typography fontWeight={700} color={'#484848'}>
        見積 {formatQuotaionNumber(props.quoteDetail.id)}
      </Typography>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>患者ID</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.patientno) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>名前</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.patientname) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>タイトル</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.title) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>担当者</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.fullname) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>日付</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.quotedate) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>医師</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.doctor) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>見積タイプ</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.type) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>ステータス</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && props.quoteDetail.statustext) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>備考</Typography>
        <Typography fontWeight={500} color={'#484848'} whiteSpace={'pre-line'}>
          {(props.quoteDetail && props.quoteDetail.note) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>最大施術時間</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.quoteDetail && `${props.quoteDetail.duration}時`) || '-'}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={'8px'}>
        <BtnGradient text='詳細' handleButtonClick={navigateToDetail} />
        <BtnGradient text='更新' handleButtonClick={() => navigateToEdit(props.quoteDetail.patientid, props.quoteDetail.id)} />
      </Stack>
    </Stack>
  );
};
export default QuotationDetail;
